/* Le widget de la fiche produit : deux feuilles, deux modeles, deux textes.
 *
 * Il ne fait que le liant. Toute la mise en page du titre vit dans
 * `apercu-titre.js`, qui est la traduction du moteur d'impression.
 *
 * Les deux feuilles sont visibles en meme temps, chacune avec sa planche :
 * un moteur par toile, un rendu par feuille, rien de partage entre les deux
 * sauf la liste des modeles et les lettres.
 *
 * Les champs visibles PORTENT les proprietes de ligne, il n'y a pas de champ
 * cache double. Le texte est normalise a la frappe, donc ce que la cliente lit
 * dans la case est ce qui sera imprime, et ce qu'elle relira dans sa
 * confirmation de commande.
 *
 * L'ajout au panier est REFUSE tant qu'un texte manque. Le `required` des
 * champs n'y suffit pas : Dawn envoie l'ajout par JavaScript, sans soumission
 * classique, et le navigateur ne verifie donc jamais rien. On se place avant
 * le code de Dawn, sur le clic du bouton et sur l'evenement de soumission.
 */
(function () {
  "use strict";

  /* Retrouve le formulaire d'ajout au panier.
   *
   * L'attribut `form` du Liquid ne peut pas servir : le contenu d'un bloc
   * « Liquid personnalise » est evalue dans un contexte isole, sans les
   * variables de la section, donc `product_form_id` y sort vide. Verifie sur
   * la boutique : l'attribut arrivait a "" et aucune propriete ne partait
   * dans la commande.
   *
   * Une fiche Dawn porte DEUX formulaires vers /cart/add : celui d'ajout au
   * panier, et celui du paiement echelonne de Shop Pay, qui vient en premier
   * dans le DOM. Prendre le premier venu accrochait les champs au mauvais.
   * On reconnait le bon a `data-type`, et a defaut au bouton d'ajout qu'il
   * est seul a contenir.
   */
  function formulaire(racine) {
    var portee = racine.closest(".product__info-container") ||
                 racine.closest(".product") || document;
    var form = portee.querySelector('form[data-type="add-to-cart-form"]') ||
               document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) {
      var candidats = [].slice.call(
        (portee === document ? document : portee)
          .querySelectorAll('form[action*="/cart/add"]'));
      form = candidats.filter(function (f) {
        return f.querySelector('[name="add"]');
      })[0] || candidats[0];
    }
    return form || null;
  }

  function rattacher(racine, form) {
    /* `form.id` en JavaScript ne rend PAS l'attribut : le formulaire de Dawn
     * contient un `<input name="id">` pour la variante, qui masque la
     * propriete. Il faut passer par getAttribute. */
    var id = form.getAttribute("id");
    if (!id) {
      id = "pc-perso-form";
      form.setAttribute("id", id);
    }
    racine.querySelectorAll("[data-modele], [data-texte]").forEach(function (c) {
      c.setAttribute("form", id);
    });
  }

  function demarrer(racine) {
    var atelier, modeles, K = 1, cache = {};
    var form = formulaire(racine);
    if (form) rattacher(racine, form);

    var alerte = racine.querySelector("[data-alerte]");
    var blocs = Array.prototype.slice.call(racine.querySelectorAll("[data-feuille]"))
      .map(function (bloc, i) {
        var toile = bloc.querySelector("[data-toile]");
        return {
          n: i + 1,
          toile: toile,
          ctx: toile.getContext("2d"),
          moteur: null,
          modele: bloc.querySelector("[data-modele]"),
          texte: bloc.querySelector("[data-texte]"),
          compte: bloc.querySelector("[data-compte]"),
          etat: bloc.querySelector("[data-etat]")
        };
      });

    function planche(fichier) {
      if (cache[fichier]) return Promise.resolve(cache[fichier]);
      return new Promise(function (ok, ko) {
        var im = new Image();
        im.onload = function () { cache[fichier] = im; ok(im); };
        im.onerror = ko;
        im.src = fichier;
      });
    }

    function rendre(f) {
      var opt = f.modele.selectedOptions[0];
      if (!opt) return;

      planche(opt.dataset.fichier).then(function (im) {
        var ctx = f.ctx, toile = f.toile;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, toile.width, toile.height);
        ctx.drawImage(im, 0, 0, toile.width, toile.height);

        /* On dessine le titre PROPRE, pas la valeur brute du champ : l'espace
         * final qu'on laisse vivre pendant la frappe compte dans la largeur
         * et ferait sauter le titre d'un cran a chaque mot commence. */
        var titre = f.moteur.normaliser(f.texte.value);
        if (titre) {
          ctx.setTransform(K, 0, 0, K, 0, 0);
          var info = f.moteur.dessiner(titre);
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          f.etat.textContent = info.lignes === 2 ? "sur deux lignes" : "sur une ligne";
        } else {
          f.etat.textContent = "";
        }

        f.compte.textContent = titre.length + " / " + atelier.C.max_car + " caracteres";
        f.compte.classList.toggle("est-plein", titre.length >= atelier.C.max_car);
        f.texte.classList.remove("est-manquant");
        etatDuBouton();
      });
    }

    /* Normalise pendant la frappe, en gardant le curseur ou il etait : sans
     * ca, corriger une faute au milieu d'un texte renvoie le curseur a la fin
     * a chaque lettre.
     *
     * `enCours` laisse vivre l'espace qu'on vient de taper. Il est retire au
     * moment ou la cliente quitte le champ, pour qu'aucune commande ne parte
     * avec un titre finissant par un blanc.
     */
    function normaliserChamp(f, enCours) {
      var input = f.texte;
      var avant = input.value, pos = input.selectionStart;
      var apres = f.moteur.normaliser(avant, enCours);
      if (apres === avant) return;
      var perdus = avant.slice(0, pos).length -
                   f.moteur.normaliser(avant.slice(0, pos), enCours).length;
      input.value = apres;
      var p = Math.max(0, pos - perdus);
      try { input.setSelectionRange(p, p); } catch (e) { /* champ non editable */ }
    }

    /* ---- le garde-fou : pas de texte, pas d'ajout au panier ------------- */

    function manquants() {
      return blocs.filter(function (f) {
        return !f.moteur || !f.moteur.normaliser(f.texte.value);
      });
    }

    function bouton() {
      return form ? form.querySelector('[name="add"], button[type="submit"]') : null;
    }

    /* Le bouton se grise quand il manque un texte. On ne touche pas a son
     * attribut `disabled` : Dawn le pilote lui-meme selon la disponibilite,
     * et on se marcherait dessus. Une classe, et le vrai refus au clic. */
    function etatDuBouton() {
      var b = bouton();
      if (!b) return;
      var incomplet = manquants().length > 0;
      b.classList.toggle("pc-perso__bouton--incomplet", incomplet);
      if (!incomplet) {
        alerte.hidden = true;
        alerte.textContent = "";
      }
    }

    function refuser(evt) {
      var m = manquants();
      if (!m.length) return;              // tout est la, Dawn peut continuer
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var f = m[0];
      alerte.textContent = m.length === 2
        ? "Écris le texte de tes deux feuilles avant d'ajouter au panier."
        : "Il manque le texte de la feuille " + f.n + ".";
      alerte.hidden = false;
      m.forEach(function (x) { x.texte.classList.add("est-manquant"); });
      try { f.texte.focus({ preventScroll: false }); } catch (e) { f.texte.focus(); }
    }

    function garder() {
      if (!form) return;
      /* En phase de CAPTURE, pour passer avant le gestionnaire de Dawn, qui
       * ecoute la soumission sur ce meme formulaire. Le clic sur le bouton
       * couvre la souris et le doigt ; la soumission couvre la touche Entree
       * dans un champ. */
      var b = bouton();
      if (b) b.addEventListener("click", refuser, true);
      form.addEventListener("submit", refuser, true);
    }

    /* Il n'y a volontairement aucune remarque du genre « un peu long » quand
     * le titre sort plus petit : la cliente voit la planche, c'est elle qui
     * juge. La note a ete essayee et retiree le 4 septembre 2026. */

    /* Le modele demande dans l'adresse, pose par l'encadre des fiches de
     * feuilles : « …/deux-feuilles-personnalisees?modele=EB001 ». La cliente
     * arrive avec SA feuille deja choisie et son apercu deja dessine, elle
     * n'a plus qu'a ecrire. Un SKU inconnu est ignore, jamais une erreur. */
    function modeleDemande() {
      try {
        var v = new URLSearchParams(location.search).get("modele");
        if (!v) return null;
        v = v.trim().toUpperCase();
        return modeles.some(function (m) { return m.sku === v; }) ? v : null;
      } catch (e) { return null; }
    }

    function brancher() {
      var demande = modeleDemande();
      blocs.forEach(function (f) {
        modeles.forEach(function (m) {
          var o = document.createElement("option");
          /* la VALEUR est ce que la commande portera, lisible pour Genevieve ;
           * le fichier de l'apercu voyage a cote, en data */
          o.value = m.sku + " " + m.titre;
          o.textContent = m.titre + " (" + m.sku + ")";
          o.dataset.fichier = m.apercu;
          if (m.sku === demande) o.selected = true;
          f.modele.appendChild(o);
        });
        f.modele.addEventListener("change", function () { rendre(f); });
        f.texte.addEventListener("input", function () {
          normaliserChamp(f, true);
          rendre(f);
        });
        f.texte.addEventListener("blur", function () {
          normaliserChamp(f, false);
          rendre(f);
        });
      });
    }

    return ApercuTitre.charger({
      constantes: racine.dataset.constantes,
      glyphes: racine.dataset.glyphes,
      planche: racine.dataset.planche
    }).then(function (a) {
      atelier = a;
      blocs.forEach(function (f) {
        f.moteur = a.moteur(f.ctx);
        K = f.toile.width / a.C.toile[0];
        f.toile.height = Math.round(a.C.toile[1] * K);
      });
      /* La liste vient de la boutique quand elle est la : un metachamp que
       * `publier_apercus.py` reecrit a chaque nouvelle feuille, sans qu'on
       * redeploie le theme. Le fichier d'assets n'est plus qu'un secours,
       * et il peut dater. */
      if (window.PC_MODELES && (window.PC_MODELES.modeles || []).length) {
        return window.PC_MODELES;
      }
      return fetch(racine.dataset.modeles).then(function (r) { return r.json(); });
    }).then(function (index) {
      modeles = index.modeles;
      brancher();
      garder();
      blocs.forEach(rendre);
    }).catch(function (e) {
      /* Si l'apercu ne charge pas, la fiche doit rester vendable : on cache
       * les dessins, jamais les champs. Le garde-fou reste en place sur les
       * textes bruts, pour qu'aucune commande ne parte vide. */
      blocs.forEach(function (f) {
        f.toile.hidden = true;
        f.moteur = { normaliser: function (t) { return String(t || "").trim(); } };
      });
      garder();
      etatDuBouton();
      if (window.console) console.error("apercu-perso :", e);
    });
  }

  function init() {
    document.querySelectorAll("[data-apercu-perso]").forEach(demarrer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
